import PropTypes from 'prop-types'
import React from 'react'

import Select2 from './Select2'
import SelectNative from './SelectNative'

import './Select.scss'

/**
 * Component of Select input with device type related behaviour (look at examples below)<br />
 * For correct work you have to pass initial option through react-final-form<br />
 * <br />
 * Note: <small>Indeed it's wrapper around two component: Select2 and SelectNative, to use it with final-form library.
 * So it would work only inside Final Form's wrapper component.
 * </small>
 * @param {object} props - properties of component
 * @return {function} render for right Select component based on mobile-native or custom select menu
 */
const Select = props => {
  const { isMobile } = props

  if (isMobile || isMobile === null) {
    return <SelectNative {...props} />
  }

  return <Select2 {...props} />
}

Select.propTypes = {
  /** Name of field */
  name: PropTypes.string.isRequired,

  /** Class Name that can be passed to control block */
  controlClassName: PropTypes.string,

  /** Custom Option component */
  customOption: PropTypes.func,

  /** Custom SingleValue component */
  customSingleValue: PropTypes.func,

  /** Flag to control active state of dropdown */
  isDisabled: PropTypes.bool,

  /** Flag to control type of select: react-select2 or native select input (for example: for mobile devices) */
  isMobile: PropTypes.bool,

  /** Flag to control color of selected option and arrow */
  isWhite: PropTypes.bool,

  /** Height of menu list */
  menuHeight: PropTypes.oneOf(['normal', 'large']),

  /** We could set custom width of menu (in em) */
  menuWidth: PropTypes.string,

  /** Array of select's options */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      label_short: PropTypes.string,
    }),
  ),

  /** Placeholder of the field */
  placeholder: PropTypes.string,

  /** Flag to control bottom margin (in forms we use it for error ) */
  skipError: PropTypes.bool,

  /** Flag to control top margin (in forms we use it for placeholder ) */
  skipPlaceholder: PropTypes.bool,

  /** Flag to control ellipsis using */
  withEllipsis: PropTypes.bool,

  /** Dropdown arrow with right indent in px (for example: for information icon) */
  withRightIndent: PropTypes.number,

  /** Flag to control visibility of underline */
  withUnderline: PropTypes.bool,

  /** Flag to set rounded corners theme */
  isRounded: PropTypes.bool,
}

Select.defaultProps = {
  isDisabled: false,
  isWhite: false,
  isMobile: null,
  withEllipsis: true,
  withUnderline: true,
  withRightIndent: 0,
  skipPlaceholder: false,
  skipError: false,
  menuHeight: 'normal',
  customOption: null,
  customSingleValue: null,
  isRounded: false,
}

export default Select
